import React from 'react';
import Image from 'components/Image';
import Heading from 'components/Heading';
import Text from 'components/Text';
import Row from 'components/Row';
import MediaObject from 'components/MediaObject';
import WavingBoy from 'assets/images/coaching/home/waving_boy.svg';

import 'components/styles/CoachingHomeWelcomeHeader.scss';

export type Props = {
  firstName?: string;
};

export default function CoachingHomeWelcomeHeader(props: Props) {
  return (
    <Row>
      <MediaObject className="CoachingHomeWelcomeHeader" figure="right" center>
        <div>
          <Row size="xsmall">
            <Heading level="1" serif flush>
              Welcome, {props.firstName}
            </Heading>
          </Row>
          <Text size="medium" color="thunder">
            Get ready for the upcoming session!
          </Text>
        </div>
        <Image src={WavingBoy} className="CoachingHomeWelcomeHeader-illustration"></Image>
      </MediaObject>
    </Row>
  );
}
